import RequestList from "./pages/ListPage.vue";
import RequestIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/request",
    component: RequestIndex,
    redirect: "/request/list",
    name: "request",
    children: [
      {
        path: "list",
        component: RequestList,
        name: "request.list",
      },
    ],
  },
];
